import * as React from 'react'
import type Label from './Label'
import styled from 'styled-components'
import { LABEL_HEIGHT } from './constants'
import { _LabelElement } from './_LabelElement'
import clsx from 'clsx'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const RoundedLabel = styled(_LabelElement)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${LABEL_HEIGHT};
  width: ${LABEL_HEIGHT};
  max-width: unset;
  border-radius: ${props => props.theme.borderRadius.round};
  padding: 0;

  /* _LabelElement uses xs radius under rebrand; icon-only labels must stay circular. */
  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: ${props => props.theme.borderRadius.round};
  }
`

interface Props extends Omit<React.ComponentProps<typeof Label>, 'children' | 'startIcon' | 'endIcon'> {
  icon: React.ReactNode
}

function IconLabel(props: Props) {
  const {
    kind,
    variant,
    icon,
    className,
    format,
    ...rest
  } = props

  return <RoundedLabel
    {...rest}
    className={clsx(
      className,
      `kind-${kind}`,
      `variant-${variant}`,
    )}
  >
    {icon}
  </RoundedLabel>
}

export default IconLabel
